(function () {
  'use strict';

  const sliders = document.querySelectorAll('.v2-hero__media--slider');

  sliders.forEach(function (slider) {
    const slides = slider.querySelectorAll('.v2-hero__slide');
    const dots = slider.querySelectorAll('.v2-hero__dot');
    const total = slides.length;
    const autoplay = parseInt(slider.dataset.autoplay || '0', 10) * 1000;
    let current = 0;
    let timer = null;

    if (total < 2) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (index + total) % total;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function start() {
      if (autoplay > 0) {
        stop();
        timer = setInterval(next, autoplay);
      }
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        start();
      });
    });

    // Pause on hover for accessibility
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    // Touch swipe (basic)
    let touchStartX = 0;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      stop();
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      const touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next();
        else goTo(current - 1);
      }
      start();
    }, { passive: true });

    start();
  });
})();
